import { IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign.ts';
import { useOnboarding } from '@/pages/Onboarding/context';
import { DominateFooter } from '@/pages/Onboarding/Layouts/OwnAI_DominateV2/components/DominateFooter';
import { canLogEvents } from '@/utils/canLogEvents';

import { getSummaryScreenConfig } from '../../utils/getSummaryScreenConfig';

import {
  ContentContainerStyles,
  PageStyles,
  PlayerContainerStyles,
} from './SummaryDeep.styles';

export const SummaryDeep: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Summary Deep',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const notes = webCampaign.getLayoutNotes();
  const config = getSummaryScreenConfig('summary-deep', notes);

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="domination" mainImage={config.mainImage}>
      <IonContent>
        <ContentContainerStyles>
          <PlayerContainerStyles>
            <Player
              src="/assets/layout-own-ai-dominate/summary_screens/summary_deep.json"
              autoplay
              loop={false}
              keepLastFrame
            />
          </PlayerContainerStyles>
        </ContentContainerStyles>
        <DominateFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
          quoteText="Good. Just one more step and I might let you please me."
          buttonText="Yes, Mistress"
          variant="with-quotes"
        />
      </IonContent>
    </PageStyles>
  );
};
